import { filterValues, isEmpty } from 'utils/object'
import { setNormalizedScore } from 'utils/score'
import { SKILL_RANGE } from './model'

export const mapInternalStateToPayload = state => {
  const { evaluators, questionComments = {} } = state

  return evaluators.reduce((acc, { comment, key, score }) => {
    const rawComments = questionComments?.[key] ?? {}
    const numericComments = filterValues(rawComments, (_, commentKey) =>
      /^\d+$/.test(String(commentKey)),
    )
    const nonEmptyComments = Object.fromEntries(
      Object.entries(numericComments).filter(([, value]) => !isEmpty(value)),
    )
    const comments = isEmpty(nonEmptyComments) ? undefined : nonEmptyComments
    const values = {
      comment,
      comments,
      score: setNormalizedScore(SKILL_RANGE)(score),
    }

    return {
      ...acc,
      [key]: Object.fromEntries(
        Object.entries(values).filter(([, value]) => value != null),
      ),
    }
  }, {})
}
